<template>
	<div>
		<button v-if="isLoggedIn" title="In winkelwagen" :class="['btn btn-primary btn-addtocart', { disabled: amount < 1 }]" @click="placeInBasket()">
			<i class="fal fa-shopping-cart" />
		</button>
		<button v-else title="Inloggen" :class="['btn btn-primary btn-addtocart', { disabled: amount < 1 }]" @click="loginPopup()">
			<i class="fal fa-shopping-cart" />
		</button>
	</div>
</template>

<script>
export default {
	props: {
		amount: {
			type: Number,
			required: true
		},
		isLoggedIn: {
			type: Boolean,
			required: true
		}
	},
	data() {
		return {
		};
	},
	methods: {
		placeInBasket() {
			this.$emit('placeInBasket');
		},
		loginPopup() {
			this.$emit('loginPopup');
		}
	}
};
</script>
